export enum KeyboardScope {
    NONE = 'none',
    DOCUMENT = 'document',
    PLAYER = 'player'
}
